module.exports = __webpack_public_path__ + "static/media/8.5c133b06.jpg";